<template>
  <div class="user-stats-bar">
    <div class="user-stats-bar__pill user-stats-bar__pill--user">
      <v-icon size="18" class="user-stats-bar__icon">mdi-account-circle</v-icon>
      <span class="user-stats-bar__value">{{ username }}</span>
    </div>
    <div class="user-stats-bar__pill user-stats-bar__pill--xp">
      <v-icon size="18" class="user-stats-bar__icon">mdi-star-four-points</v-icon>
      <span class="user-stats-bar__label">{{ xpName }}</span>
      <span class="user-stats-bar__value">{{ formattedXp }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserStatsBar',
  props: {
    username: {
      type: String,
      default: '',
    },
    xpName: {
      type: String,
      default: 'XP',
    },
    xpValue: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    formattedXp() {
      return this.xpValue.toLocaleString('de-DE');
    },
  },
};
</script>

<style lang="scss" scoped>
.user-stats-bar {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin: 4px 0 20px;
}

.user-stats-bar__pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 16px;
  border-radius: 999px;
  font-size: 0.9rem;
  line-height: 1.2;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.14);
  backdrop-filter: blur(2px);
}

.user-stats-bar__pill--user {
  color: rgba(255, 255, 255, 0.85);
}

.user-stats-bar__pill--xp {
  background: rgba(255, 193, 7, 0.12);
  border-color: rgba(255, 193, 7, 0.4);
  color: #ffca28;
  font-weight: 600;
}

.user-stats-bar__icon {
  color: inherit;
}

.user-stats-bar__label {
  opacity: 0.85;
  font-weight: 500;
}

.user-stats-bar__value {
  font-weight: 700;
}

@media (max-width: 599px) {
  .user-stats-bar {
    gap: 8px;
    margin-bottom: 16px;
  }

  .user-stats-bar__pill {
    font-size: 0.82rem;
    padding: 5px 12px;
  }
}
</style>
